export default "__VITE_ASSET__BdAxWBz1__"